import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    standalone: true,
    name: 'timezone'
})
export class TimezonePipe implements PipeTransform {
    transform(timestamp: number, offset: number): number {
        return timestamp + offset;
    }
}
